import { Location } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    HostListener,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DownloadComponent } from 'src/app/shared/components/download/download.component';
import { AreaTypeService } from 'src/app/shared/services/area-type.service';
import { DebugService } from 'src/app/shared/services/debug.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { FilterService } from 'src/app/shared/services/filter.service';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { PopupService } from 'src/app/shared/services/popup.service';
import { CacheService } from './../../../shared/services/cache.service';
import { GlobeService } from './../../../shared/services/globe.service';
import { RemoveDuplicatesByIdPipe } from '../../explore_mapbox/filter/filter.component';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
    paramTid;
    paramRid;

    expanded = true;
    showSpinner = false;

    filterData = null;
    filters = null;
    sampleCount = 0;
    measureCount = 0;

    selectedSampleType = null;
    selectedShapeType = null;

    showModal = false;
    modalBoxFilterValues = null;

    showDialog = false;
    agree = false;

    seaAreaFilter = { id: 'seaAreas', value: 'Area' };
    seaAreas = [];
    subAreas = [];
    modalTitle = '';

    ss = {
        ss11: null,
        ss21: null,
        ss31: null,
        ss41: null,
        ss12: null,
        ss22: null,
        ss32: null,
        ss42: null,
    };

    openedFilterControl = null;
    openedFilterValueSet = null;
    mainFilterControl = null;
    defaultValueSet = null;
    oldSelectedValueSet = null;
    newSelectedValueSet = null;
    userSelectedValueSet = null;
    selectionPristine = true;
    defaultFilterResult = null;

    filterValues: any;

    activeComponent: any;

    defaultValues = { min: -1, max: 9999 };
    relevantValues = { min: -1, max: 9999 };
    oldSelectionValues = { min: null, max: null };
    newSelectionValues = { min: null, max: null };
    userSelectedSliderValue = false;

    helpContent;
    lastUpdate: string;

    cacheKeys = {
        cacheKey11: 'marisSeaWaterIHO',
        cacheKey21: 'marisBiotaIHO',
        cacheKey31: 'marisSedimentIHO',
        cacheKey41: 'marisSuspendedMatterIHO',
        cacheKey12: 'marisSeaWaterFAO',
        cacheKey22: 'marisBiotaFAO',
        cacheKey32: 'marisSedimentFAO',
        cacheKey42: 'marisSuspendedMatterFAO',
    };

    resetSlider = false;

    @ViewChild('dataSelectorTemplate') dataSelectorTemplate: TemplateRef<any>;
    @ViewChild('sliderTemplate') sliderTemplate: TemplateRef<any>;
    @ViewChild('filterValuesListTemplate')
    filterValuesListTemplate: TemplateRef<any>;

    constructor(
        private cacheService: CacheService,
        private viewContainerRef: ViewContainerRef,
        private cdRef: ChangeDetectorRef,
        private debugService: DebugService,
        private filterService: FilterService,
        private globeService: GlobeService,
        private downloadService: DownloadService,
        private dialogService: DialogService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private loadingService: LoadingService,
        private popupService: PopupService,
        private areaTypeService: AreaTypeService
    ) {
        this.route.params.subscribe((params) => {
            this.paramTid = params['tid'];
            this.paramRid = params['rid'];
        });

        this.helpContent = {
            sampleTypes:
                'Data from a single sample type - seawater, biota, sediment or suspended matter can be accessed at one time. Choose the sample type of interest using the tab on the left.',
            shapeTypes:
                "Refine data by marine geographic areas using the 'area type' and 'areas' filters. Currently, two marine region types are supported: IHO Sea Areas and FAO Major Fishing Areas (see 'Help' for more details).",
            seaAreas:
                'For each area type, marine areas and nested sub-areas are presented in the popup window on the globe/ map. To filter the data, deselect areas that are not of interest.',
            nuclides:
                'Filter by radionuclide(s) (defined by mass number and symbol of the element, e.g. 137Cs).',
            samplingYears:
                'Filter by the year(s) in which the samples were collected.',
            dataSets:
                "Filter by source datasets. Individual datasets can be explored via the 'Datasets' page.",
            samplingDepth:
                "Filter by a range of sampling depths (m). A value of '-1' indicates that sample depth information is not available. The min and max values above the depth slider are user selected values. The min and max values below the depth slider indicate relevant sample depth range based on the other filter selections. The min and max values on the left and right side of the depth slider indicate the default sample depth range.",
            bioGroups:
                'Filter by group(s) of related species (e.g. crustaceans, fish etc.) and by taxonomic identifier(s).The taxonomic identifier list is comprised of values representing the most detailed taxonomic information available for each sample and contains information from different taxon ranks (e.g. species, genus etc.).',
            bodyParts: 'Filter by the part(s) of the organism(s) analysed.',
            sedimentTypes:
                'Filter by sediment type(s). The list of values is based on the Udden-Wentworth scale.',
            export: 'Drag export data box if it covers the filter',
        };
    }

    ngOnInit(): void {
        this.dialogService.activeComponent().subscribe((activeComponent) => {
            if (!activeComponent) {
                this.closeDialog();
            }
            this.activeComponent = activeComponent;
        });
    }

    ngAfterViewInit(): void {
        this.showSpinner = true;
        this.loadingService.setLoadingStatus(this.showSpinner);

        this.cacheService.isCached().subscribe((cached) => {
            if (cached) {
                this.filterData = this.cacheService.getMarisData().filterData;
                this.lastUpdate =
                    this.cacheService.getMarisData().lastUpdate.lastUpdate;

                this.ss.ss11 = this.cacheService.getMarisData().masterData.ss11;
                this.ss.ss21 = this.cacheService.getMarisData().masterData.ss21;
                this.ss.ss31 = this.cacheService.getMarisData().masterData.ss31;
                this.ss.ss41 = this.cacheService.getMarisData().masterData.ss41;
                this.ss.ss12 = this.cacheService.getMarisData().masterData.ss12;
                this.ss.ss22 = this.cacheService.getMarisData().masterData.ss22;
                this.ss.ss32 = this.cacheService.getMarisData().masterData.ss32;
                this.ss.ss42 = this.cacheService.getMarisData().masterData.ss42;

                this.switchSampleType(
                    this.filterData.filterValues.sampleType[0]
                );
                this.switchShapeType(this.filterData.filterValues.shapeType[0]);
                this.resetAll();

                if (this.paramTid) {
                    if (!this.paramRid) {
                        this.paramRid = null;
                        this.applyFilter('reset');
                    } else {
                        this.applyFilter('ref');
                    }
                }

                this.filters = this.filterData.configuration.all.map((data) => {
                    return {
                        id: data.id,
                        value: data.value,
                        tp:
                            data.tp == 'dataSelectorTemplate'
                                ? this.dataSelectorTemplate
                                : this.sliderTemplate,
                    };
                });
                this.initDepthSlider();
                this.cdRef.detectChanges();
            }
        });

        this.globeService.getSampleCount().subscribe((count) => {
            this.sampleCount = count;
        });

        this.globeService.getMeasureCount().subscribe((count) => {
            this.measureCount = count;
        });

        this.globeService.getLoadingComplete().subscribe((result) => {
            if (result.complete == 1) {
                this.showSpinner = false;
                this.loadingService.setLoadingStatus(this.showSpinner);
            }
        });
    }

    @HostListener('click', ['$event'])
    public handleClick(event) {
        if (event.target.id == 'container') {
            console.log('clicked on dialog');
            this.openDialog();
        }
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDownHandler(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.closeDialog();
        }
    }

    constructSeaArea(shapeTypeId: number) {
        this.seaAreas =
            this.filterData.filterValues.seaAreas['sh' + shapeTypeId];
        this.subAreas = this.seaAreas.map((data) => {
            return data.subarea
                ? JSON.parse(
                      '[' +
                          data.subarea
                              .replace('&amp;#x0D;', '')
                              .replace(/\n/g, '') +
                          ']'
                  )
                : [data];
        });

        this.subAreas = this.subAreas.reduce((acc, val) => acc.concat(val), []);
    }

    switchSampleType(sampleType: any, isClicked?: boolean) {
        this.selectedSampleType = sampleType;
        if (!this.selectedShapeType) {
            this.selectedShapeType = this.filterData.filterValues.shapeType[0];
        }
        if (isClicked) {
            this.location.replaceState('/explore');
        }
    }

    switchShapeType(shapeType: any) {
        this.selectedShapeType = shapeType;
    }

    userSwitchSampleType(sampleType: any, isClicked?: boolean) {
        this.switchSampleType(sampleType, isClicked);
        this.resetAll(true);
        this.areaTypeService.setBoundaryStatus({
            showBoundaryStatus: false,
            shapeTypeId: this.selectedShapeType.id,
        });
    }

    userSwitchShapeType(shapeType: any) {
        this.switchShapeType(shapeType);
        this.resetAll(true);
        this.areaTypeService.setBoundaryStatus({
            showBoundaryStatus: false,
            shapeTypeId: this.selectedShapeType.id,
        });
    }

    initDepthSlider() {
        let samplingDepth = JSON.parse(this.ss.ss11[0].filtervalue)
            .samplingDepth[0];
        this.defaultValues.min = samplingDepth.min;
        this.defaultValues.max = samplingDepth.max;
        this.relevantValues.min = samplingDepth.min;
        this.relevantValues.max = samplingDepth.max;
        this.oldSelectionValues.min = samplingDepth.min;
        this.oldSelectionValues.max = samplingDepth.max;
        this.newSelectionValues.min = samplingDepth.min;
        this.newSelectionValues.max = samplingDepth.max;

        this.resetSlider = false;

        setTimeout(() => {
            this.resetSlider = true;
            this.userSelectedSliderValue = false;
        }, 100);
    }

    isActive(valueType: string, id: number) {
        switch (valueType) {
            case 'sampleType':
                return this.selectedSampleType.id == id;
            case 'shapeType':
                return this.selectedShapeType.id == id;
        }
    }

    getSampleTypeIcon(sampleTypeId: number) {
        let extension =
            this.selectedSampleType.id == sampleTypeId ? '.svg' : '_white.svg';
        return '/assets/icons/svg/st' + sampleTypeId + '_icon' + extension;
    }

    toggleFilterPanel() {
        this.expanded = !this.expanded;
    }

    showFilter(filterId: string) {
        let occuranceArray =
            this.filterData.configuration['st' + this.selectedSampleType.id];
        return occuranceArray.includes(filterId);
    }

    constructFilterValues(filter: any) {
        let newSelectedValueSet = JSON.parse(
            JSON.stringify(this.newSelectedValueSet[filter.id].data)
        );
        switch (filter.id) {
            case 'seaAreas':
                this.modalBoxFilterValues = {
                    id: filter.id,
                    tp: this.filterValuesListTemplate,
                    isAllSelected: true,
                    isAllCollapsed: true,
                    parentChild: true,
                    flexWidth: 33,
                    values: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                    defaultValues: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                };
                break;
            case 'bioGroups':
                this.modalBoxFilterValues = {
                    id: filter.id,
                    tp: this.filterValuesListTemplate,
                    isAllSelected: true,
                    isAllCollapsed: true,
                    parentChild: true,
                    flexWidth: 33,
                    values: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                    defaultValues: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                };
                break;
            case 'bodyParts':
                this.modalBoxFilterValues = {
                    id: filter.id,
                    tp: this.filterValuesListTemplate,
                    isAllSelected: true,
                    isAllCollapsed: true,
                    parentChild: false,
                    flexWidth: 25,
                    values: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                    defaultValues: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                };
                break;
            case 'dataSets':
                this.modalBoxFilterValues = {
                    id: filter.id,
                    tp: this.filterValuesListTemplate,
                    isAllSelected: true,
                    isAllCollapsed: true,
                    parentChild: false,
                    flexWidth: 25,
                    values: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                    defaultValues: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                };
                break;
            case 'samplingDepth':
                break;
            default:
                this.modalBoxFilterValues = {
                    id: filter.id,
                    tp: this.filterValuesListTemplate,
                    isAllSelected: true,
                    isAllCollapsed: true,
                    parentChild: false,
                    flexWidth: 16,
                    values: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                    defaultValues: this.selectionControl(
                        newSelectedValueSet,
                        filter.id
                    ),
                };
                break;
        }
        this.unhideFilterValues();
    }

    selectionControl(newSelectedValueSet: any, filterId: string) {
        let result = {
            multiColumns: false,
            data: [],
        };

        let values;

        if (this.mainFilterControl == null && this.selectionPristine) {
            values = JSON.parse(JSON.stringify(newSelectedValueSet));
        } else {
            values = JSON.parse(
                JSON.stringify(this.newSelectedValueSet[filterId].data)
            );
        }

        if (filterId == 'seaAreas' || filterId == 'bioGroups') {
            result.multiColumns = true;
            let columns = 3;
            let rows = Math.round(values.length / columns);

            for (let i = 0; i < columns; i++) {
                var arr = [];
                for (let j = 0; j <= rows; j++) {
                    var value = values[3 * j + i];
                    if (value) {
                        arr.push(value);
                    }
                }
                result.data.push(arr);
            }
        } else {
            result.data = values;
        }

        return result;
    }

    showPopup(filter: any) {
        this.hidePopup();
        this.modalTitle = 'Refine ' + filter.value;
        this.constructFilterValues(filter);
        this.showModal = true;
        this.openedFilterControl = filter;
        this.debugService.output(
            'Filter',
            'showPopup',
            this.openedFilterControl
        );
    }

    hidePopup() {
        this.showModal = false;
        this.openedFilterControl = null;
        this.modalBoxFilterValues = null;
    }

    q(searchValue: string) {
        if (searchValue !== '') {
            this.unhideFilterValues();

            this.modalBoxFilterValues.values.data.forEach((item) => {
                if (Array.isArray(item)) {
                    item.forEach((data) => {
                        let count = 0;
                        data.childList.forEach((element) => {
                            if (
                                element.value
                                    .toString()
                                    .toUpperCase()
                                    .indexOf(searchValue.toUpperCase()) == -1
                            ) {
                                element.isHidden = true;
                            } else {
                                count += 1;
                            }
                        });

                        if (count == 0) {
                            data.isHidden = true;
                        }
                    });
                } else {
                    let count = 0;
                    if (item.childList) {
                        item.childList.forEach((element) => {
                            if (
                                element.value
                                    .toString()
                                    .toUpperCase()
                                    .indexOf(searchValue.toUpperCase()) == -1
                            ) {
                                element.isHidden = true;
                            } else {
                                count += 1;
                            }
                        });

                        if (count == 0) {
                            item.isHidden = true;
                        }
                    } else {
                        if (
                            item.value
                                .toString()
                                .toUpperCase()
                                .indexOf(searchValue.toUpperCase()) == -1
                        ) {
                            item.isHidden = true;
                        }
                    }
                }
            });
        } else {
            this.unhideFilterValues();
        }
    }

    unhideFilterValues() {
        this.modalBoxFilterValues.values.data.forEach((item) => {
            if (Array.isArray(item)) {
                item.forEach((data) => {
                    data.isHidden = false;
                    if (data.childList) {
                        data.childList.forEach((element) => {
                            element.isHidden = false;
                        });
                    }
                });
            } else {
                item.isHidden = false;
                if (item.childList) {
                    item.childList.forEach((element) => {
                        element.isHidden = false;
                    });
                }
            }
        });
    }

    getCount(filterId: string) {
        if (
            this.defaultValueSet[filterId].count ==
            this.newSelectedValueSet[filterId].count
        ) {
            return 'All';
        } else {
            return this.newSelectedValueSet[filterId].count + ' selected';
        }
    }

    getSliderData(data: string) {
        switch (data) {
            case 'defaultValues':
                return this.defaultValues;

            case 'relevantValues':
                return this.relevantValues;

            case 'oldSelectionValues':
                return this.oldSelectionValues;

            case 'newSelectionValues':
                return this.newSelectionValues;
        }
    }

    resetAll(isClicked?: boolean) {
        this.hidePopup();
        this.popupService.setPopupStatus('reset');

        this.showSpinner = true;
        this.loadingService.setLoadingStatus(this.showSpinner);

        if (isClicked) {
            this.paramRid = null;
            this.paramTid = null;
        }

        if (!this.paramRid && !this.paramTid) {
            this.applyFilter('reset');
        }

        this.mainFilterControl = null;
        this.defaultValueSet =
            this.filterData.defaultFilterValues[
                'ss' + this.selectedSampleType.id + this.selectedShapeType.id
            ];

        const pipe = new RemoveDuplicatesByIdPipe();
        this.defaultValueSet['nuclides'].data = pipe.transform(this.defaultValueSet['nuclides'].data);


        this.initDepthSlider();
        //TODO: reset slider DOM

        this.oldSelectedValueSet = JSON.parse(
            JSON.stringify(this.defaultValueSet)
        );
        this.newSelectedValueSet = JSON.parse(
            JSON.stringify(this.defaultValueSet)
        );

        this.selectionPristine = true;
    }

    resetAreas() {
        let keys = Object.keys(this.defaultValueSet);
        let result = {};
        for (const key of keys) {
            result[key] = this.defaultValueSet[key];
        }

        this.newSelectedValueSet = JSON.parse(JSON.stringify(result));
    }

    resetFilters() {
        let keys = Object.keys(this.defaultValueSet);
        let result = {};
        result['seaAreas'] = this.newSelectedValueSet['seaAreas'];
        for (const key of keys) {
            if (key != 'seaAreas') {
                result[key] = this.defaultValueSet[key];
            }
        }

        this.newSelectedValueSet = JSON.parse(JSON.stringify(result));
    }

    //Click event on parent checkbox
    parentCheck(parentObj) {
        parentObj.isIndeterminate = false;
        if (parentObj.childList) {
            for (var i = 0; i < parentObj.childList.length; i++) {
                if (!parentObj.childList[i].isDisabled) {
                    parentObj.childList[i].isSelected = parentObj.isSelected;
                }
            }
        }
    }

    //Click event on child checkbox
    childCheck(parentObj, childObj) {
        // parentObj.isSelected = childObj.every(function (itemChild: any) {
        //   return itemChild.isSelected == true;
        // });
        let selectCount = 0;
        childObj.forEach((itemChild) => {
            if (itemChild.isSelected == true) {
                selectCount += 1;
            }
        });
        if (selectCount == childObj.length) {
            parentObj.isSelected = true;
        }
        if (selectCount == 0) {
            parentObj.isSelected = false;
        }

        if (selectCount > 0 && selectCount < childObj.length) {
            parentObj.isSelected = false;
            parentObj.isIndeterminate = true;
        }
    }

    //Click event on master select
    selectUnselectAll(obj, select) {
        if (select) {
            obj.isAllSelected = true;
        } else {
            obj.isAllSelected = false;
        }

        if (Array.isArray(obj.values.data[0])) {
            obj.values.data.forEach((item) => {
                for (var i = 0; i < item.length; i++) {
                    if (!item[i].isDisabled) {
                        item[i].isSelected = obj.isAllSelected;
                    }
                    if (obj.parentChild) {
                        for (var j = 0; j < item[i].childList.length; j++) {
                            if (!item[i].childList[j].isDisabled) {
                                item[i].childList[j].isSelected =
                                    obj.isAllSelected;
                            }
                        }
                    }
                }
            });
        } else {
            for (var i = 0; i < obj.values.data.length; i++) {
                if (!obj.values.data[i].isDisabled) {
                    obj.values.data[i].isSelected = obj.isAllSelected;
                }
                if (obj.parentChild) {
                    for (
                        var j = 0;
                        j < obj.values.data[i].childList.length;
                        j++
                    ) {
                        if (!obj.values.data[i].childList[j].isDisabled) {
                            obj.values.data[i].childList[j].isSelected =
                                obj.isAllSelected;
                        }
                    }
                }
            }
        }
    }

    //Expand/Collapse event on each parent
    expandCollapse(obj) {
        obj.isClosed = !obj.isClosed;
    }

    //Master expand/ collapse event
    expandAll(obj) {
        obj.values.data.forEach((item) => {
            for (var i = 0; i < item.length; i++) {
                item[i].isClosed = false;
            }
        });
        obj.isAllCollapsed = false;
    }

    collapseAll(obj) {
        obj.values.data.forEach((item) => {
            for (var i = 0; i < item.length; i++) {
                item[i].isClosed = true;
            }
        });
        obj.isAllCollapsed = true;
    }

    applyFilter(mode: string, isSliderChange?: boolean) {
        //mode: "reset" => reset to default, "ref" => dataset view, "filter" => user selection view
        if (mode == 'reset') {
            let selectedSampleType;

            this.showSpinner = true;
            this.loadingService.setLoadingStatus(this.showSpinner);

            if (this.paramTid) {
                this.filterData.filterValues.sampleType.forEach((item) => {
                    if (item.id == this.paramTid) {
                        selectedSampleType = item;
                    }
                });
                this.switchSampleType(selectedSampleType);
                this.resetAll();
            }

            let filterValues = {
                sampleTypeId: this.selectedSampleType.id,
                areaId: null,
                subAreaId: null,
                nuclideId: null,
                samplingYear: null,
                reference: null,
                samplingDepthFrom: null,
                samplingDepthTo: null,
                bioGroup: null,
                bodyPar: null,
                sedimentType: null,
                shapeTypeId: this.selectedShapeType.id,
                reset: true,
                cacheKey:
                    this.cacheKeys[
                        'cacheKey' +
                            this.selectedSampleType.id +
                            this.selectedShapeType.id
                    ],
                lastUpdate: this.lastUpdate,
                search: false,
            };

            this.filterValues = filterValues;

            this.globeService.sendfilterValue(filterValues);
        }

        if (mode == 'ref') {
            let selectedSampleType;

            this.filterData.filterValues.sampleType.forEach((item) => {
                if (item.id == this.paramTid) {
                    selectedSampleType = item;
                }
            });
            this.switchSampleType(selectedSampleType);
            this.resetAll();

            let filterValues = {
                sampleTypeId: parseInt(this.paramTid),
                areaId: null,
                subAreaId: null,
                nuclideId: null,
                samplingYear: null,
                reference: this.paramRid,
                samplingDepthFrom: null,
                samplingDepthTo: null,
                bioGroup: null,
                bodyPar: null,
                sedimentType: null,
                shapeTypeId: 1,
                reset: false,
                cacheKey: null,
                lastUpdate: null,
                search: true,
            };

            this.filterValues = filterValues;

            if (this.paramRid) {
                this.oldSelectedValueSet['dataSets'].data.forEach((item) => {
                    if (item.id != parseInt(this.paramRid)) {
                        item.isSelected = false;
                    }
                });
                this.oldSelectedValueSet['dataSets'].count = 1;

                this.mainFilterControl = { id: 'dataSets', value: 'dataSets' };
                this.filterService
                    .getFilterValues(this.filterValues)
                    .subscribe((result) => {
                        this.userSelectedValueSet = null;
                        //let resultObj = JSON.parse(JSON.parse(result[0].resultData).filtervalue);
                        let resultObj = result.filterValue;

                        this.updateFilterValueSet(resultObj);

                        this.globeService.sendfilterValue(filterValues);
                    });
            } else {
                this.globeService.sendfilterValue(filterValues);
            }
        }

        if (mode == 'filter') {
            //this.unhideFilterValues();
            this.selectionPristine = false;
            this.userSelectedValueSet = this.newSelectedValueSet;

            if (!isSliderChange) {
                if (Array.isArray(this.modalBoxFilterValues.values.data[0])) {
                    this.modalBoxFilterValues.values.data =
                        this.modalBoxFilterValues.values.data.flat();
                }

                var defaultValuesData =
                    this.modalBoxFilterValues.defaultValues.data.flat();

                if (
                    JSON.stringify(this.modalBoxFilterValues.values.data) ==
                    JSON.stringify(defaultValuesData)
                ) {
                    this.hidePopup();
                    return;
                }

                this.userSelectedValueSet[this.openedFilterControl.id].data =
                    this.modalBoxFilterValues.values.data;
                this.userSelectedValueSet[
                    this.openedFilterControl.id
                ].count = 0;

                this.modalBoxFilterValues.values.data.forEach((item) => {
                    if (item.childList) {
                        let count = item.childList.filter((el) => {
                            return el.isSelected && !el.isDisabled;
                        }).length;
                        this.userSelectedValueSet[
                            this.openedFilterControl.id
                        ].count += count;
                    } else {
                        if (item.isSelected && !item.isDisabled) {
                            this.userSelectedValueSet[
                                this.openedFilterControl.id
                            ].count += 1;
                        }
                    }
                });
            }

            this.mainFilterControl = this.openedFilterControl;
            this.oldSelectedValueSet = JSON.parse(
                JSON.stringify(this.userSelectedValueSet)
            );

            this.hidePopup();

            this.showSpinner = true;
            this.loadingService.setLoadingStatus(this.showSpinner);

            this.filterValues = this.constructFilterValueMapping();
                console.log('filterValues', this.filterValues);
            this.globeService.sendfilterValue(this.filterValues);

            this.filterService
                .getFilterValues(this.filterValues)
                .subscribe((result) => {
                    this.userSelectedValueSet = null;
                    this.userSelectedSliderValue = false;
                    //let resultObj = JSON.parse(JSON.parse(result[0].resultData).filtervalue);
                    let resultObj = result.filterValue;

                    this.updateFilterValueSet(resultObj);
                });

            this.location.replaceState('/explore');
        }
    }

    applySliderValue(event) {
        this.userSelectedSliderValue = true;
        var changed = false;

        if (event.changed == 'min') {
            this.oldSelectionValues.min = +event.min;
        } else {
            this.oldSelectionValues.max = +event.max;
        }

        if (this.newSelectionValues.min != +event.min) {
            changed = true;
            this.newSelectionValues.min = +event.min;
        }

        if (this.newSelectionValues.max != +event.max) {
            changed = true;
            this.newSelectionValues.max = +event.max;
        }

        if (changed == true) {
            this.openedFilterControl = {
                id: 'samplingDepth',
                value: 'Sampling Depth (m)',
            };
            this.newSelectedValueSet.samplingDepth.min =
                this.newSelectionValues.min;
            this.newSelectedValueSet.samplingDepth.max =
                this.newSelectionValues.max;
            this.applyFilter('filter', true);
        }
    }

    constructFilterValueMapping() {
        //this.filterMapping
        let result = {};
        let keys = Object.keys(this.userSelectedValueSet);

        const samplingDepthIndex = keys.indexOf('samplingDepth');
        if (samplingDepthIndex > -1) {
            keys.splice(samplingDepthIndex, 1);
        }

        const sampleTypeIndex = keys.indexOf('sampleType');
        if (sampleTypeIndex > -1) {
            keys.splice(sampleTypeIndex, 1);
        }

        for (const key of keys) {
            let data = this.userSelectedValueSet[key].data;
            let selected = [];
            data.forEach((item) => {
                if (item.childList) {
                    item.childList.forEach((child) => {
                        if (child.isSelected == true) {
                            selected.push(child);
                        }
                    });
                } else {
                    if (item.isSelected == true) {
                        selected.push(item);
                    }
                }
            });

            let ssValue = JSON.parse(
                this.ss[
                    'ss' +
                        this.selectedSampleType.id +
                        this.selectedShapeType.id
                ][0].filtervalue
            )[key];

            if (selected.map((x) => x.id).length == ssValue.length) {
                result[key] = null;
            } else {
                result[key] = selected.map((x) => x.id).join();
            }
        }

        let filterMapping = {
            sampleTypeId: this.selectedSampleType.id,
            areaId: result['seaAreas'],
            subAreaId: result['seaAreas'],
            nuclideId: result['nuclides'],
            samplingYear: result['samplingYears'],
            reference: result['dataSets'],
            samplingDepthFrom: this.userSelectedSliderValue
                ? parseInt(this.newSelectionValues.min)
                : this.oldSelectionValues.min,
            samplingDepthTo: this.userSelectedSliderValue
                ? parseInt(this.newSelectionValues.max)
                : this.oldSelectionValues.max,
            bioGroup: result.hasOwnProperty('bioGroups')
                ? result['bioGroups']
                : null,
            bodyPar: result.hasOwnProperty('bodyParts')
                ? result['bodyParts']
                : null,
            sedimentType: result.hasOwnProperty('sedimentTypes')
                ? result['sedimentType']
                : null,
            shapeTypeId: this.selectedShapeType.id,
            reset: false,
            cacheKey: null,
            lastUpdate: null,
            search: true,
        };

        return filterMapping;
    }

    updateFilterValueSet(result: any) {
        let newFilterValueSet = {};
        let keys = Object.keys(this.oldSelectedValueSet);

        const samplingDepthIndex = keys.indexOf('samplingDepth');
        if (samplingDepthIndex > -1) {
            keys.splice(samplingDepthIndex, 1);
        }

        const sampleTypeIndex = keys.indexOf('sampleType');
        if (sampleTypeIndex > -1) {
            keys.splice(sampleTypeIndex, 1);
        }

        for (const key of keys) {
            let newData = [];
            if (key != this.mainFilterControl.id) {
                let idList = result[key];
                if (idList && key == 'seaAreas') {
                    idList = idList.map((val) => {
                        return val.trim();
                    });
                }
                let data = this.oldSelectedValueSet[key].data;
                let count = 0;

                data.forEach((item) => {
                    if (item.childList) {
                        //TODO: check indeterminate state
                        let subcount = 0;
                        let subcount_unchecked = 0;
                        item.isDisabled = true;
                        item.childList.forEach((child) => {
                            if (idList && !idList.includes(child.id)) {
                                child.isDisabled = true;
                            }

                            if (
                                idList &&
                                idList.includes(child.id) &&
                                child.isSelected
                            ) {
                                child.isDisabled = false;
                                subcount += 1;
                            }

                            if (
                                idList &&
                                idList.includes(child.id) &&
                                !child.isSelected
                            ) {
                                child.isDisabled = false;
                                subcount_unchecked += 1;
                            }

                            if (!idList) {
                                child.isDisabled = true;
                            }
                        });
                        if (subcount > 0 || subcount_unchecked > 0) {
                            item.isDisabled = false;
                        }
                        count += subcount;
                    } else {
                        if (idList && !idList.includes(item.id)) {
                            item.isDisabled = true;
                        }

                        if (
                            idList &&
                            idList.includes(item.id) &&
                            item.isSelected
                        ) {
                            item.isDisabled = false;
                            count += 1;
                        }

                        if (
                            idList &&
                            idList.includes(item.id) &&
                            !item.isSelected
                        ) {
                            item.isDisabled = false;
                        }

                        if (!idList) {
                            item.isDisabled = true;
                        }
                    }
                    newData.push(item);
                });

                if (key == 'seaAreas' || key == 'bioGroups') {
                    newData.sort(this.dynamicSort('value'));
                }
                newFilterValueSet[key] = { count: count, data: newData };
            } else {
                if (key == 'seaAreas' || key == 'bioGroups') {
                    this.oldSelectedValueSet[key].data.sort(
                        this.dynamicSort('value')
                    );
                }
                newFilterValueSet[key] = this.oldSelectedValueSet[key];
            }
        }

        this.checkRangeOverlap(result, newFilterValueSet);

        this.newSelectedValueSet = newFilterValueSet;
        //this.filterValues = newFilterValueSet;
        return newFilterValueSet;
    }

    checkRangeOverlap(result, newFilterValueSet) {
        var resultMin = parseInt(result.samplingDepthFrom);
        var resultMax = parseInt(result.samplingDepthTo);

        var resultRange = {
            min: isNaN(resultMin) ? 0 : resultMin,
            max: isNaN(resultMax) ? 0 : resultMax,
        };

        if (
            this.oldSelectionValues.min >= resultRange.min &&
            this.oldSelectionValues.min <= resultRange.max
        ) {
            this.newSelectionValues.min = this.oldSelectionValues.min;
        } else {
            this.newSelectionValues.min = resultRange.min;
        }

        if (
            this.oldSelectionValues.max >= resultRange.min &&
            this.oldSelectionValues.max <= resultRange.max
        ) {
            this.newSelectionValues.max = this.oldSelectionValues.max;
        } else {
            this.newSelectionValues.max = resultRange.max;
        }

        if (
            (this.oldSelectionValues.min > resultRange.min &&
                this.oldSelectionValues.min > resultRange.max) ||
            (this.oldSelectionValues.max < resultRange.min &&
                this.oldSelectionValues.max < resultRange.min)
        ) {
            this.newSelectionValues.min = -999;
            this.newSelectionValues.max = -999;
        }

        if (this.oldSelectionValues.min == null) {
            this.newSelectionValues.min = resultRange.min;
        }

        if (this.oldSelectionValues.max == null) {
            this.newSelectionValues.max = resultRange.max;
        }

        this.relevantValues = {
            min: isNaN(resultMin) ? 0 : resultMin,
            max: isNaN(resultMax) ? 0 : resultMax,
        };

        newFilterValueSet['samplingDepth'] = {
            min: isNaN(resultMin) ? 0 : resultMin,
            max: isNaN(resultMax) ? 0 : resultMax,
        };
    }

    openDialog() {
        this.downloadService.setFilterValue(this.filterValues);
        this.showDialog = !this.showDialog;
        this.dialogService.displayComponent(DownloadComponent);
    }

    closeDialog() {
        this.showDialog = false;
    }

    getHelpContent(filter: string) {
        return this.helpContent[filter];
    }

    dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === '-') {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            if (typeof a[property] == 'number') {
                return a[property] - b[property];
            } else {
                return a[property].toLowerCase() < b[property].toLowerCase()
                    ? -1
                    : a[property].toLowerCase() > b[property].toLowerCase()
                    ? 1
                    : 0;
            }
        };
    }
}
